<script setup>
import { computed } from 'vue'

const props = defineProps({
  author: { type: Object, required: true },
  size: { type: String, default: 'base' }, // 'xs' | 'sm' | 'base' | 'full'
})

const BOX = {
  xs: 'h-5 w-5',
  sm: 'h-6 w-6',
  base: 'h-8 w-8',
  full: 'h-full w-full',
}

const INITIALS_TEXT = {
  xs: 'text-[9px]',
  sm: 'text-[10px]',
  base: 'text-xs',
  full: 'text-xs',
}

// Emoji read smaller than initials at the same font size, so they get a step up.
const EMOJI_TEXT = {
  xs: 'text-[10px]',
  sm: 'text-xs',
  base: 'text-sm',
  full: 'text-sm',
}

const PALETTE = ['bg-rose-500', 'bg-amber-500', 'bg-emerald-600', 'bg-sky-500', 'bg-violet-500', 'bg-teal-600']

const initials = computed(() =>
  (props.author?.display_name || '?')
    .split(/\s+/)
    .map((w) => w[0])
    .filter(Boolean)
    .slice(0, 2)
    .join('')
    .toUpperCase()
)

const color = computed(() => {
  const name = props.author?.display_name || ''
  let h = 0
  for (const c of name) h = (h * 31 + c.charCodeAt(0)) % 997
  return PALETTE[h % PALETTE.length]
})
</script>

<template>
  <img
    v-if="author?.avatar_url"
    :src="author.avatar_url"
    alt=""
    class="shrink-0 rounded-full object-cover"
    :class="BOX[size]"
  />
  <div
    v-else-if="author?.emoji"
    class="flex shrink-0 items-center justify-center rounded-full bg-muted leading-none"
    :class="[BOX[size], EMOJI_TEXT[size]]"
  >
    {{ author.emoji }}
  </div>
  <div
    v-else
    class="flex shrink-0 items-center justify-center rounded-full font-semibold text-white"
    :class="[BOX[size], INITIALS_TEXT[size], color]"
  >
    {{ initials }}
  </div>
</template>
